import { readable, writable } from 'svelte/store';
import Cipher from "./classes/Cipher";
import InputComponent from "./classes/InputComponent";
import { modulo } from './utils'

// Input store
export const InputStore = writable({})
export const ResultStore = writable([])


// Cipher library
export const CipherStore = readable([
  new Cipher({
    id: 'CaeserCipher',
    name: 'Caezerova šifra',
    description: 'Posunie text',
    crypt: function (input, action) {
      const { text, shift } = input;
      const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      let output = '';

      for (let i = 0; i < text.length; i++) {
        const char = text[i];
        if (/[a-zA-Z]/.test(char)) {
          const isUpperCase = char === char.toUpperCase();
          const charIndex = alphabet.indexOf(char.toUpperCase());
          let newIndex;

          if (action === 'encrypt') {
            newIndex = (charIndex + shift) % 26;
          } else {
            newIndex = (charIndex - shift + 26) % 26;
          }

          const newChar = alphabet[newIndex];
          output += isUpperCase ? newChar : newChar.toLowerCase();
        } else {
          output += char;
        }
      }

      return [output];
    },
    input: [
      {
        id: 'text',
        value: '',
        component: new InputComponent({ component: { textarea: true }, type: '', height: 5 })
      },
      {
        id: 'shift',
        value: 0,
        component: new InputComponent({ component: { input: true }, type: 'number', placeholder: 'Posun...' })
      }
    ],
    buttons: [
      {
        action: 'encrypt',
        label: 'Zašifrovať'
      },
      {
        action: 'decrypt',
        label: 'Dešifrovať'
      },
    ]
  }),
  new Cipher({
    id: 'VigenereCipher',
    name: 'Vigenèrova šifra',
    description: 'Použije kľúč na zašifrovanie textu',
    crypt: function (input, action) {
      const { text, key } = input;
      const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      let output = '';
      let keyIndex = 0;

      for (let i = 0; i < text.length; i++) {
        const char = text[i];
        if (/[a-zA-Z]/.test(char)) {
          const isUpperCase = char === char.toUpperCase();
          const charIndex = alphabet.indexOf(char.toUpperCase());
          const keyChar = key[keyIndex % key.length].toUpperCase();
          const keyShift = alphabet.indexOf(keyChar);
          let newIndex;

          if (action === 'encrypt') {
            newIndex = (charIndex + keyShift) % 26;
          } else {
            newIndex = (charIndex - keyShift + 26) % 26;
          }

          const newChar = alphabet[newIndex];
          output += isUpperCase ? newChar : newChar.toLowerCase();
          keyIndex++;
        } else {
          output += char;
        }
      }

      return [output];
    },
    input: [
      {
        id: 'text',
        value: '',
        component: new InputComponent({ component: { textarea: true }, type: '', height: 5 })
      },
      {
        id: 'key',
        value: '',
        component: new InputComponent({ component: { input: true }, type: 'text', placeholder: 'Kľúč...' })
      }
    ],
    buttons: [
      {
        action: 'encrypt',
        label: 'Zašifrovať'
      },
      {
        action: 'decrypt',
        label: 'Dešifrovať'
      },
    ]
  }),
  new Cipher({
    id: 'MorseCipher',
    name: 'Morseova šifra',
    description: 'Zakóduje text do morseovej abecedy',
    crypt: function (input, action) {
      const { text } = input;
      const morseAlphabet = {
        'A': '.-', 'B': '-...', 'C': '-.-.', 'D': '-..', 'E': '.', 'F': '..-.',
        'G': '--.', 'H': '....', 'I': '..', 'J': '.---', 'K': '-.-', 'L': '.-..',
        'M': '--', 'N': '-.', 'O': '---', 'P': '.--.', 'Q': '--.-', 'R': '.-.',
        'S': '...', 'T': '-', 'U': '..-', 'V': '...-', 'W': '.--', 'X': '-..-',
        'Y': '-.--', 'Z': '--..', '0': '-----', '1': '.----', '2': '..---',
        '3': '...--', '4': '....-', '5': '.....', '6': '-....', '7': '--...',
        '8': '---..', '9': '----.', ' ': '/'
      };
      let output = '';

      if (action === 'encrypt') {
        for (let i = 0; i < text.length; i++) {
          const char = text[i].toUpperCase();
          if (morseAlphabet[char]) {
            output += morseAlphabet[char] + '/';
          } else {
            output += char;
          }
        }
      } else {
        const words = text.split('/');
        for (let i = 0; i < words.length; i++) {
          const word = words[i];
          if (word) {
            let decodedWord = '';
            const letters = word.split(' ');
            for (let j = 0; j < letters.length; j++) {
              const letter = letters[j];
              const decodedLetter = Object.keys(morseAlphabet).find(key => morseAlphabet[key] === letter);
              if (decodedLetter) {
                decodedWord += decodedLetter;
              } else {
                decodedWord += letter;
              }
            }
            output += decodedWord + ' ';
          }
        }
      }

      return [output.trim()];
    },
    input: [
      {
        id: 'text',
        value: '',
        component: new InputComponent({ component: { textarea: true }, type: '', height: 5 })
      }
    ],
    buttons: [
      {
        action: 'encrypt',
        label: 'Zakódovať'
      },
      {
        action: 'decrypt',
        label: 'Dekódovať'
      },
    ]
  })
]);
        